import { AggregationCountEffects } from './aggregation.effects';
import { AppsEffects } from './apps.effects';
import { AuthEffects } from './auth.effects';
import { AuthorizationSystemsEffects } from './authorization-systems.effects';
import { BundleEffects } from './bundles.effects';
import { CustomEffects } from './custom.effects';
import { DashboardEffects } from './dashboard.effects';
import { EninvoiceEffects } from './eninvoice.effects';
import { GstFilingEffects } from './gst-filing.effects';
import { IdentityProvidersEffects } from './identity-providers.effects';
import { InstancesEffects } from './instances.effects';
import { IntegrationEffects } from './integrations.effects';
import { LocationEffects } from './locations.effects';
import { ManageAppsEffects } from './manage-apps.effects';
import { MasterEffects } from './master-management.effects';
import { NotificationPreferencesEffects } from './notification-preferences.effects';
import { NotificationEffects } from './notifications.effects';
import { OrchestrationAssistantEffects } from './orchestration-assistant.effects';
import { PackageEffects } from './packages.effects';
import { PartnerEffects } from './partner.effects';
import { PermissionsEffects } from './permissions.effects';
import { RecordsEffects } from './records.effects';
import { ReportsEffects } from './reports.effects';
import { RequestEffects } from './requests.effects';
import { RolesEffects } from './roles.effects';
import { SearchEffects } from './search.effects';
import { SessionEffects } from './session.effects';
import { SharedEffects } from './shared.effects';
import { TagsEffects } from './tags.effects';
import { TasksEffects } from './tasks.effects';
import { TokenEffects } from './tokens.effects';
import { TransformationEffects } from './transformations.effects';
import { UserEffects } from './users.effects';
import { widgetTranslateEffects } from './widget.effects';
import { WorkflowEffects } from './workflow.effects';
import { UiPreferencesEffects } from './ui-preferences.effects';

export const Effects = [
    AuthEffects,
    AuthorizationSystemsEffects,
    EninvoiceEffects,
    SessionEffects,
    SharedEffects,
    UserEffects,
    IntegrationEffects,
    ManageAppsEffects,
    TagsEffects,
    AppsEffects,
    BundleEffects,
    PackageEffects,
    widgetTranslateEffects,
    LocationEffects,
    PartnerEffects,
    TokenEffects,
    InstancesEffects,
    TransformationEffects,
    RequestEffects,
    ReportsEffects,
    WorkflowEffects,
    GstFilingEffects,
    NotificationEffects,
    NotificationPreferencesEffects,
    RecordsEffects,
    RolesEffects,
    MasterEffects,
    DashboardEffects,
    PermissionsEffects,
    IdentityProvidersEffects,
    SearchEffects,
    AggregationCountEffects,
    CustomEffects,
    TasksEffects,
    OrchestrationAssistantEffects,
    UiPreferencesEffects,
];
